<nav class="navbar navbar-dark ori-header">
  <div class="container ori-header__container">
    <div class="navbar-left">
      <div *ngIf="isAuthorized" class="ori-header__toggle-navigation"
           (click)="toggleNavigation.emit()"
           [inlineSVG]="navIcon"
      ></div>
      <a class="navbar-brand" [routerLink]="['/']">
        <img src="../../../../assets/ori_logo_white.png">
      </a>
    </div>
    <div class="ori-header__title">
      {{pageTitle$|async}}
    </div>
    <s-ori-user
      [userAvatar]="userAvatar"
      [userName]="userName"
      [userPosition]="userPosition"
    ></s-ori-user>
  </div>
</nav>
